<template>
  <div>
    <div class="m-input-box">
      <div class="m-label">
        <span class="m-txt">{{label}}</span>
        <input class="m-input" :class="'align-'+this.textAlign" :type="type" :value="inputModel"
               :placeholder="placeholder" :disabled="disabled"
               :maxlength="maxlength" v-model="inputModel" @input="handleInput" @blur="blur"/>
        <button class="m-right">
          <slot></slot>
        </button>
      </div>
      <div v-show="errMsg !== ''" class="m-msg" :class="'align-'+this.textAlign"><span>&nbsp;</span><em >{{errMsg}}</em></div>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    label: {
      type: String,
      default: ' '
    },
    type: {
      type: String,
      default: 'text'
    },
    value: {
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: true
    },
    rules: {},
    placeholder: {
      type: String,
      default: '请输入...'
    },
    maxlength: {
      type: Number,
      default: 20
    },
    minNum: {
      type: String
    },
    maxNum: {
      type: String
    },
    labelCode: {
      type: String
    },
    textAlign: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      inputModel: this.value,
      errMsg: ''
    }
  },
  methods: {
    handleInput (event) {
      let value = event.target.value
      this.$emit('input', value, false) //触发 input 事件，并传入新值
    },
    blur () {
      let str
      this.rules && (str = this.rules.substring(1, this.rules.length - 1))
      let reg = new RegExp(str)
      if (this.required && this.inputModel === '') {
        this.errMsg = '此处为必填项'
      } else if (!reg.test(this.inputModel)) {
        this.errMsg = '填写的格式不正确'
      } else if (this.labelCode === 'age' && (parseInt(this.inputModel) > parseInt(this.maxNum) || parseInt(this.inputModel) < parseInt(this.minNum))) {
        this.errMsg = `年龄需要在${this.minNum}-${this.maxNum}之间`
      } else {
        this.errMsg = ''
      }
    }
  },
  watch: {
    'value' (newV, oldV) {
      if (newV !== oldV) {
        this.inputModel = newV
      }
    },
    'inputModel' () {
      let str
      this.rules && (str = this.rules.substring(1, this.rules.length - 1))
      let reg = new RegExp(str)
      if (this.required) {
        if (this.inputModel === '') {
          this.$emit('suited', false)
        } else {
          if (reg.test(this.inputModel)) {
            if (this.maxNum && this.minNum && this.labelCode === 'age') {
              let errMsg = `年龄需要在${this.minNum}-${this.maxNum}之间`
              if (parseInt(this.inputModel) > parseInt(this.maxNum) || parseInt(this.inputModel) < parseInt(this.minNum)) {
                this.errMsg = errMsg
                this.$emit('suited', false)
              } else {
                this.errMsg = ''
                this.$emit('suited', true)
              }
            } else {
              this.errMsg = ''
              this.$emit('suited', true)
            }
          } else {
            if (this.labelCode === 'name') {
              this.errMsg = '姓名必须为全中文或者全英文'
            }
            this.$emit('suited', false)
          }
        }
      } else {
        if (this.labelCode === 'weight' || this.labelCode === 'height') {
          if (reg.test(this.inputModel)) {
            let label = this.labelCode === 'weight' ? '体重' : '身高'
            let errMsg = `${label}必须在${this.minNum}-${this.maxNum}之间`
            if (parseInt(this.inputModel) > parseInt(this.maxNum) || parseInt(this.inputModel) < parseInt(this.minNum)) {
              this.errMsg = errMsg
              this.$emit('suited', false)
            } else {
              this.$emit('suited', true)
            }
          }
        } else {
          this.$emit('suited', true)
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style ref="stylesheet/scss" lang="scss" scoped>
  .m-input-box {
    padding-left: 15px;
    border-bottom: 1px solid #f5f5f5;
    background-color: #ffffff;
    .m-label {
      display: flex;
      width: 100%;
      line-height: 50px;
      .m-txt {
        width: 84px;
        font-size: 16px;
        text-align: left;
      }
      .m-input {
        margin-top: 13px;
        height: 25px;
        line-height: 25px;
        flex: 1;
        padding-right: 15px;
        font-size: 14px;
        border: none;
        &.align-right {
          text-align: right;
        }
      }
      .m-right {
        padding-right: 15px;
        font-size: 14px;
        background-color: transparent;
        border: none;
      }
    }

    .m-msg {
      display: inline-flex;
      width: 100%;
      height: 30px;
      font-size: 14px;
      color: #ff0000;
      background-color: #ffffff;
      &.align-right {
        text-align: right;
        padding-right: 30px;
      }
      > span {
        width: 84px;
      }
      > em {
        flex: 1;
      }
    }
  }
</style>
